// extracted by mini-css-extract-plugin
export var checkbox = "_a0-0";
export var circle = "_a0-3";
export var horizontalContainer = "_a0-7";
export var sm = "_a0-5";
export var switch0 = "_a0-2";
export var switchDisabled = "_a0-8";
export var switchEnabled = "_a0-1";
export var textSwitchContainer = "_a0-9";
export var textSwitchOption = "_a0-a";
export var textSwitchOptionSelected = "_a0-b";
export var verticalContainer = "_a0-6";
export var xs = "_a0-4";